module.exports = __webpack_public_path__ + "media/images/icons/icons_large/37_twolistnote-43af2a4002c1a8ac6e547580d0fadb0e.png";